var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationVirtualcard = function SvgSimpleIllustrationVirtualcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__virtualcard_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__virtualcard_svg__st3{fill:#fff2b2}.simple-illustration__virtualcard_svg__st4{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__virtualcard_svg__st7{fill:#002140}")), /*#__PURE__*/React.createElement("path", {
    d: "m36.899 8.004-24.966.048L7 12.411l.191 41.356s.689 4.615 4.567 5.471c3.877.857 21.595.514 24.591.514s5.121-4.77 5.121-4.77-.231-38.021-.032-41.312c.2-3.291-4.535-5.67-4.535-5.67l-.004.004z",
    style: {
      fill: "#cf4cd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.072 54.194c-.076 3.264 3.953 4.989 3.953 4.989l2.602.255-2.602-3.064V11.156l2.734-3.152-2.734.406-3.666 3.208s-.207 39.312-.283 42.575h-.004z",
    style: {
      fill: "#49225b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.374 12.156h-24.46v43.632h24.723l-.263-43.632z",
    style: {
      fill: "#fed607"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st3",
    d: "M25.203 12.292c-.279 1.004.311 2.1 1.18 2.678.869.578 1.949.733 2.993.761 1.044.028 2.096-.052 3.124.12.279.048.566.116.789.287.231.171.379.434.49.701.737 1.729.259 3.722.526 5.583.072.49.199.984.47 1.399.745 1.136 2.383 1.363 3.67.92V12.156l-13.242.136zM38.167 27.996c-1.028-.092-1.968.701-2.383 1.646-.418.944-.426 2.008-.426 3.041 0 1.502-.008 3.005-.008 4.507 0 1.152 0 2.343.446 3.407s1.446 1.981 2.602 1.961L38.175 28l-.008-.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st4",
    d: "M35.767 8.004H12.862a5.671 5.671 0 0 0-5.671 5.671v40.093a5.671 5.671 0 0 0 5.671 5.671h22.906a5.671 5.671 0 0 0 5.671-5.671V13.674a5.672 5.672 0 0 0-5.672-5.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st4",
    d: "M16.233 59.438a5.67 5.67 0 0 1-5.671-5.671V13.674a5.67 5.67 0 0 1 5.671-5.671"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st4",
    d: "M37.378 12.057H15.13c-.645 0-1.168.523-1.168 1.168v41.412c0 .645.523 1.168 1.168 1.168h22.248c.645 0 1.168-.523 1.168-1.168V13.224c0-.644-.523-1.167-1.168-1.167z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.325 15.125H21.126a2.934 2.934 0 0 0-2.934 2.935v20.686a2.935 2.935 0 0 0 2.934 2.935h39.199a2.934 2.934 0 0 0 2.934-2.935V18.059a2.934 2.934 0 0 0-2.934-2.934z",
    style: {
      fill: "#03d47c"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st4",
    d: "M59.818 15h-38.31A3.509 3.509 0 0 0 18 18.508v19.527a3.508 3.508 0 0 0 3.508 3.508h38.309a3.508 3.508 0 0 0 3.508-3.508V18.508A3.507 3.507 0 0 0 59.818 15zM22.269 37.2l6.131.008M31.209 37.208l6.127.008"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.51 29.677v-4.995c.004-.262-.488-.472-1.093-.472h-3.992c-.339 0-.66.062-.866.176l-1.362.749c-.148.082-.23.183-.23.289v3.629c0 .098.066.191.191.269l1.018.628c.207.129.546.203.905.203h4.332c.605-.004 1.093-.215 1.097-.472v-.004z",
    style: {
      fill: "#8eecc4"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__virtualcard_svg__st7",
    d: "M58.724 19H42.619A1.62 1.62 0 0 0 41 20.619v2.794a1.62 1.62 0 0 0 1.619 1.619h16.105a1.62 1.62 0 0 0 1.62-1.619v-2.794A1.62 1.62 0 0 0 58.724 19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "simple-illustration__virtualcard_svg__st7",
    cx: 27,
    cy: 48,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.156 46.017a.6.6 0 0 1 .126.839l-2.611 3.536-1.876-1.713a.6.6 0 1 1 .81-.886l.893.815 1.82-2.464a.598.598 0 0 1 .838-.127z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fed607"
    }
  }));
};
export default SvgSimpleIllustrationVirtualcard;